import { render, staticRenderFns } from "./demo2.vue?vue&type=template&id=cc59074e&scoped=true"
import script from "./demo2.vue?vue&type=script&lang=js"
export * from "./demo2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc59074e",
  null
  
)

export default component.exports